export enum SoarQueryKeys {
  AUTOMATION_RULES = 'AUTOMATION_RULES',
  PLAYBOOKS = 'PLAYBOOKS',
  PLAYBOOK_DETAILS = 'PLAYBOOK_DETAILS',
  PLAYBOOK_EXECUTION_ACTIONS = 'PLAYBOOK_EXECUTION_ACTIONS',
  PLAYBOOK_EXECUTION = 'PLAYBOOK_EXECUTION',
  PLAYBOOK_EXECUTIONS_BY_RECOMMENDATION = 'PLAYBOOK_EXECUTIONS_BY_RECOMMENDATION',
  CATALOG_ENTITIES = 'CATALOG_ENTITIES',
  CATALOG_EVENTS = 'CATALOG_EVENTS',
  CATALOG_ACTIONS = 'CATALOG_ACTIONS',
  CATALOG_CONDITIONS = 'CATALOG_CONDITIONS',
  ZIA_URL_CATEGORIES = 'ZIA_URL_CATEGORIES',
  OKTA_GROUPS = 'OKTA_GROUPS',
  TEMPLATES = 'TEMPLATES',
}
